const COOKIE_NAME = 'hb_geo_location_overlay_dismissed';
const FOCUSABLE_SELECTORS = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

export class OverlayClass {
  private readonly overlay: HTMLElement;
  private previouslyFocused: HTMLElement | null = null;
  private handleKeyDown: (e: KeyboardEvent) => void;

  constructor(overlay: HTMLElement) {
    this.overlay = overlay;
    this.handleKeyDown = this.trapFocus.bind(this);

    if (!this.isCookieSet()) {
      this.openOverlay();
    }

    overlay.querySelectorAll<HTMLElement>('[data-geo-location-overlay-close]').forEach((button) => {
      button.addEventListener('click', () => this.closeOverlay());
    });
  }

  private openOverlay(): void {
    this.previouslyFocused = document.activeElement as HTMLElement;
    this.overlay.setAttribute('tabindex', '-1');
    this.overlay.classList.add('is-visible');
    document.addEventListener('keydown', this.handleKeyDown);
    this.overlay.focus();
  }

  private closeOverlay(): void {
    this.overlay.classList.remove('is-visible');
    document.removeEventListener('keydown', this.handleKeyDown);

    if (!this.isCookieSet()) {
      this.setCookie();
    }

    this.previouslyFocused?.focus();
  }

  private trapFocus(e: KeyboardEvent): void {
    if (e.key === 'Escape') {
      this.closeOverlay();
      return;
    }

    if (e.key !== 'Tab') {
      return;
    }

    const focusable = this.getFocusableElements();
    if (focusable.length === 0) {
      return;
    }

    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  private getFocusableElements(): HTMLElement[] {
    return Array.prototype.slice.call(this.overlay.querySelectorAll<HTMLElement>(FOCUSABLE_SELECTORS)) as HTMLElement[];
  }

  private isCookieSet(): boolean {
    return document.cookie.split(';').some((c) => c.trim().indexOf(COOKIE_NAME + '=') === 0);
  }

  private setCookie(): void {
    const expires = new Date();
    expires.setDate(expires.getDate() + 30);
    document.cookie = `${COOKIE_NAME}=1; expires=${expires.toUTCString()}; path=/; SameSite=Lax`;
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll<HTMLElement>('[data-geo-location-overlay]').forEach((el) => {
    new OverlayClass(el);
  });
});